import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';

import { Content, InvisualFilter } from '@23degrees/shared-code/models';

export interface IContentEvent<T = undefined> {
  slug: string;
  context?: T;
}

export interface IExtendedMouseEvent {
  event: MouseEvent;
  dataRef: Record<string, any>;
  position: [number, number];
}

export interface IData {
  id: string;
  rows: Record<string, any>[];
}

export interface IContentPickerEvent {
  slug?: string;
  request?: boolean;
}

export interface IFilterEvent {
  filter: InvisualFilter;
}

export interface IHighlightEvent {
  active: boolean;
  dataRef: Record<string, any>;
}

@Injectable({
  providedIn: 'root',
})
export class EventBus {
  // TODO figure out if this is good or bad?
  // content & data
  public content = new BehaviorSubject<IContentEvent<Content>>(null);
  public data = new BehaviorSubject<IContentEvent<IData>>(null);

  // Data Table Hot emits this event when new Data is pasted
  public hotClearData = new Subject<IContentEvent>();

  // Mouse Events
  public mouseClick = new Subject<IContentEvent<IExtendedMouseEvent>>();
  public mouseEnter = new Subject<IContentEvent<IExtendedMouseEvent>>();
  public mouseLeave = new Subject<IContentEvent<IExtendedMouseEvent>>();
  public mouseMove = new Subject<IContentEvent<IExtendedMouseEvent>>();

  // Content Picker
  public contentPicker = new Subject<IContentEvent<IContentPickerEvent>>();

  // Actions
  public filterChange = new Subject<IContentEvent<IFilterEvent>>();
  public highlightChange = new Subject<IContentEvent<IHighlightEvent>>();
  public tooltipChange = new Subject<IContentEvent<IHighlightEvent>>();

  // Content Preview
  public resizeActive = new Subject<IContentEvent<{ active: boolean }>>();
  public previewSize = new BehaviorSubject<IContentEvent<{ width: number; height: number }>>({ slug: null, context: { width: 0, height: 0 } });

  // ECharts
  public eChart = new Subject<IContentEvent<{ nodes: any; links: any }>>();

  // Content Items with dynamic Height inside ToolTips
  public dynamicHeight = new Subject<IContentEvent<{ height: number;  referenceID: string}>>();

}
